// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-tips {
    background-color: var(--ce-grey-2);
    border-radius: var(--border_radius_lg);
    padding: var(--card-padding);
    margin-bottom: var(--card-padding);
    position: relative;
    max-width: 680px;
}

.product-tips > header {
    display: flex;
    position: absolute;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    left: 0;
    top: 0;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    background: var(--ce-grey-5);
}

.product-tips > header h2 {
    margin: 0;
    padding: 0;
}

.product-tips > header h3{
    color: var(--ce-grey-55);
}

.product-tips > header button {
    appearance: none;
    background-color: transparent;
    color: var(--icon-grey);
    font-size: 20px;
    border: none;
    width: 50px;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 26px 20px;
}
.product-tips > header button:last-of-type {
    justify-content: flex-end;
}

.product-tip .title {
    padding: 40px 0 5px 0;
    margin: 0 auto;
    text-align: center;
    position: relative;
    z-index: 1;
    font-size: 24px;
    text-wrap: balance;
}

.product-tip .title h2 {
    margin-bottom: 5px;
}

.product-tip .title h3 {
    font-style: italic;
    font-weight: normal;
}

.product-tip img {
    max-width: 100%;
    padding: .5em;
    border-radius: var(--border_radius);
    overflow: hidden;
    border: var(--border);
    background: #fff;
    margin: .5em 0;
}

.product-tip .editor-controls-button {
    margin-top: 10px;
}

@media (max-width: 575.98px) {
    .product-tip .title h2 {
        font-size: 20px;
    }
    .product-tip .title h3 {
        font-size: 16px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Authentication/Coordinator/ProductTips.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,sCAAsC;IACtC,4BAA4B;IAC5B,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,OAAO;IACP,MAAM;IACN,4BAA4B;IAC5B,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mCAAmC;IACnC,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".product-tips {\n    background-color: var(--ce-grey-2);\n    border-radius: var(--border_radius_lg);\n    padding: var(--card-padding);\n    margin-bottom: var(--card-padding);\n    position: relative;\n    max-width: 680px;\n}\n\n.product-tips > header {\n    display: flex;\n    position: absolute;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    left: 0;\n    top: 0;\n    border-top-left-radius: 20px;\n    border-top-right-radius: 20px;\n    background: var(--ce-grey-5);\n}\n\n.product-tips > header h2 {\n    margin: 0;\n    padding: 0;\n}\n\n.product-tips > header h3{\n    color: var(--ce-grey-55);\n}\n\n.product-tips > header button {\n    appearance: none;\n    background-color: transparent;\n    color: var(--icon-grey);\n    font-size: 20px;\n    border: none;\n    width: 50px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    padding: 26px 20px;\n}\n.product-tips > header button:last-of-type {\n    justify-content: flex-end;\n}\n\n.product-tip .title {\n    padding: 40px 0 5px 0;\n    margin: 0 auto;\n    text-align: center;\n    position: relative;\n    z-index: 1;\n    font-size: 24px;\n    text-wrap: balance;\n}\n\n.product-tip .title h2 {\n    margin-bottom: 5px;\n}\n\n.product-tip .title h3 {\n    font-style: italic;\n    font-weight: normal;\n}\n\n.product-tip img {\n    max-width: 100%;\n    padding: .5em;\n    border-radius: var(--border_radius);\n    overflow: hidden;\n    border: var(--border);\n    background: #fff;\n    margin: .5em 0;\n}\n\n.product-tip .editor-controls-button {\n    margin-top: 10px;\n}\n\n@media (max-width: 575.98px) {\n    .product-tip .title h2 {\n        font-size: 20px;\n    }\n    .product-tip .title h3 {\n        font-size: 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
